//================================================================
//  Page: Subnet
//================================================================

//  Purpose: This page shows the current Subnet

//  Example:
//    <Subnet></Subnet>    

//================================================================


// Libraries
import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';

// Contexts
import { GetUser, GetRoles } from '../../../../Library/GlobalContexts';

// Components
import PageComponent from '../../../../Components/PageComponent/PageComponent';
import TabView from '../../../../Components/TabView/TabView';
import BreadCrumbs from '../../../../Components/Breadcrumbs/BreadCrumbs';

// Tabs
import Overview from './Tabs/Overview';

// Functions
import DocumentListener from '../../../../Library/DocumentListener';
import CheckInventoryRole from '../../../../Library/CheckInventoryRole';

// CSS
import './Subnet.css';


export default function Subnet() {

    //------------------------------------------------------
    //  React Router & useContexts 
    //------------------------------------------------------

    const navigate = useNavigate();
    const routerUseLocation = useLocation();
    const params = useParams();

    const getUser = useContext(GetUser);
    const getRoles = useContext(GetRoles);

    //------------------------------------------------------
    //  useStates
    //------------------------------------------------------

    // Used to save page status > 'pending', 'onload', 'error-invalid', 'error-fatal'
    const [pageStatus, setPageStatus] = useState('pending');

    // Holds the application document from 
    const [subnetDoc, setSubnetDoc] = useState();

    //------------------------------------------------------
    //  useEffects
    //------------------------------------------------------

    // Query Listener
    // - Get all Overview with the status of 'Active'
    useEffect(() => {

        const subnetId = params.id;

        if (subnetId === '') return;
        if (subnetId === null) return;
        if (getRoles === undefined) return;
        if (getUser === undefined) return;

        // ============================================
        //  Perform role check
        // ============================================

        const roleStatus = CheckInventoryRole('subnets', getRoles, getUser);
        if (roleStatus === 'access-denied') return navigate('/inventory?view=subnets');

        // ============================================
        //  Fetch Data
        // ============================================

        function onLoadChange(document) {

            if (document === undefined) return  setPageStatus('forbidden');

            setSubnetDoc(document);
            setPageStatus('onload');

        }

        function onError(error) {

            console.log(error);
            setPageStatus('error-fatal');

        }

        const unsubscribe = DocumentListener('subnets', subnetId, onLoadChange, onLoadChange, onError);

        return () => {
            unsubscribe();
        };

        // eslint-disable-next-line
    }, [getRoles, getUser]);

    //------------------------------------------------------
    //  HTML
    //------------------------------------------------------

    return (
        <PageComponent
            pageStatus={pageStatus}
            header={
                <div className='Page-Header-Container' hidden={pageStatus !== 'onload'}>

                    <BreadCrumbs
                        rootLinkName='Subnet'
                        rootLinkRoute={`/${routerUseLocation.pathname.split('/')[1]}?view=subnets`}
                        childLinkName={subnetDoc?.subnetip}
                    ></BreadCrumbs>

                    <div className='flex flex-row gap-4'>
                        <p className='font-medium text-[20px] mb-0'>{subnetDoc?.subnetip}</p>
                    </div>

                </div>
            }
            body={
                <TabView
                    defaultView={1}

                    //------------------------------------------------------
                    // Overview
                    //------------------------------------------------------

                    oneTitle={'Overview'}
                    oneRoute={`/inventory/subnet/${params.id}?view=overview`}
                    oneContent={
                        <Overview></Overview>
                    }

                ></TabView>
            }
        ></PageComponent>
    )
}
